export default "__VITE_PUBLIC_ASSET__7556cfef__"